﻿import { ProductState } from '../models/enums';

export abstract class RenderingFunctions {

    public static returnProductStateColor(productState: ProductState) {
        switch (productState) {
            case ProductState.Raw:
                return "product-state-raw";
            case ProductState.Bulk:
                return "product-state-bulk";
            case ProductState.Intermediate:
                return "product-state-intermediate";
            case ProductState.FinishedGood:
                return "product-state-fg";
            case ProductState.Working:
                return "product-state-working";
            default:
                return "";
        }
    }

    public static returnProductStateName(productState: ProductState) {
        switch (productState) {
            case ProductState.Raw:
                return "RAW";
            case ProductState.Bulk:
                return "BULK";
            case ProductState.Intermediate:
                return "INTERMEDIATE";
            case ProductState.FinishedGood:
                return "FINISHED GOOD";
            case ProductState.Working:
                return "WORKING";
            default:
                return "";
        }
    }

}